// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6c421afc","225":"37d47ef7","787":"30dbe271"}[chunkId] + ".chunk.js";
};